<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h3>{{ item.name }}</h3>
        <div class="card-header-edit" v-on:click.stop="studioEditClicked">
          <i class="fas fa-ellipsis-v"></i>
        </div>
      </div>
      <div class="card-body">
        <p>{{ this.item.hours }} std. | Gewinn: {{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR'
          }).format(this.item.profit * 2/3) }}</p>
      </div>
    </div>

    <div class="col-md-4">
      <modal :show.sync="modals.editStudio"
             body-classes="p-0"
             modal-classes="modal-dialog-centered modal-sm">
        <card body-classes="px-lg-5 py-lg-5" class="border-0"
              header-classes="bg-white pb-5"
              shadow
              type="secondary">
          <template>
            <div class="text-center text-muted mb-4">
              <h3>{{ this.item.name }}</h3>
              <small>Studio bearbeiten</small>
              <div v-if="this.item.verified === false">
                <small>
                  <router-link :to="{ name: 'register', params: { verification_key: this.item.verification_key }}">
                    Studio Aktivieren
                  </router-link>
                </small>
              </div>
            </div>
            <form role="form">
              <base-input addon-left-icon="ni ni-single-02" alternative class="mb-3" placeholder="Name"
                          v-model="editStudio.name">
              </base-input>

              <div class="row">
                <div class="col">
                  <base-button @click.stop="removeStudioPressed" block class="my-4" type="danger">Löschen</base-button>
                </div>
                <div class="col">
                  <base-button @click="updateStudio" block class="my-4" type="primary">Speichern</base-button>
                </div>
              </div>
            </form>
          </template>
        </card>
      </modal>
    </div>
    <div class="col-md-4">
      <modal :show.sync="modals.removeStudio"
             gradient="danger"
             modal-classes="modal-danger modal-dialog-centered">

        <div class="py-3 text-center">
          <i class="ni ni-bell-55 ni-3x"></i>
          <h4 class="heading mt-4">Studio wirklich löschen?</h4>
          <p>Wenn Sie das Studio löschen kann es und die darin angelegten Kunden sowie Projekte nicht wiederhergestellt
            werden.</p>
        </div>

        <template slot="footer">
          <base-button @click="removeStudio()" type="white">Ok, Löschen</base-button>
          <base-button @click="modals.removeStudio = false"
                       class="ml-auto"
                       text-color="white"
                       type="link">
            Schließen
          </base-button>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
  import firebase from 'firebase/app';
  import 'firebase/firestore';

  export default {
    name: "StudiosListItem",
    data() {
      return {
        modals: {
          editStudio: false,
          removeStudio: false
        },
        editStudio: {
          name: ''
        }
      }
    },
    props: {
      item: {
        id: String,
        name: String,
        hours: Boolean,
        profit: Boolean,
        verified: Boolean,
        verification_key: String
      }
    },
    methods: {
      removeStudio() {
        firebase.firestore().collection("studios").doc(this.item.id).delete().then(() => {
          this.modals.removeStudio = false;
          this.modals.editStudio = false;
        }).catch(function (error) {
          // eslint-disable-next-line no-console
          console.error("Error removing document: ", error);
        });

        firebase.firestore().collection("customers").where("studio_id", "==", this.item.id).get()
          .then(function (querySnapshot) {
            querySnapshot.forEach(function (doc) {

              firebase.firestore().collection("projects").where("customer", "==", doc.id).get()
                .then(function (querySnapshot) {
                  querySnapshot.forEach(function (doc) {
                    firebase.firestore().collection("projects").doc(doc.id).delete().then(function () {
                    }).catch(function (error) {
                      // eslint-disable-next-line no-console
                      console.error("Error removing document: ", error);
                    });
                  });
                })
                .catch(function (error) {
                  // eslint-disable-next-line no-console
                  console.log("Error getting documents: ", error);
                });


              firebase.firestore().collection("customers").doc(doc.id).delete().then(function () {
              }).catch(function (error) {
                // eslint-disable-next-line no-console
                console.error("Error removing document: ", error);
              });

            });
          })
          .catch(function (error) {
            // eslint-disable-next-line no-console
            console.log("Error getting documents: ", error);
          });
      },
      removeStudioPressed() {
        this.modals.removeStudio = true
      },
      studioEditClicked() {
        this.modals.editStudio = true
      },
      updateStudio() {
        var studioRef = firebase.firestore().collection("studios").doc(this.item.id);
        return studioRef.update({
          name: this.editStudio.name
        })
          .then(() => {
            this.modals.editStudio = false
          })
          .catch(function (error) {
            // eslint-disable-next-line no-console
            console.error("Error updating document: ", error);
          });
      },
      getCustomers() {
        firebase.firestore().collection('customers').where("studio_id", "==", this.item.id)
          .onSnapshot((querySnapshot) => {
            this.item.profit = 0;
            this.item.hours = 0;
            querySnapshot.forEach((doc) => {
              firebase.firestore().collection("projects").where("customer", "==", doc.id).where('billed', '==', false)
                .onSnapshot((querySnapshot) => {
                  querySnapshot.forEach((doc) => {
                    this.item.profit = Number(this.item.profit) + (Number(doc.data().hourly_rate) * Number(doc.data().hours));
                    this.item.hours = Number(this.item.hours) + Number(doc.data().hours);
                  });
                });
            });
          });
      }
    },
    created() {
      this.getCustomers();
      this.editStudio.name = this.item.name;
    }
  }
</script>

<style scoped>
  .card {
    cursor: pointer;
    padding: 0;
    background-color: #FFFFFF;
    border-radius: 5px;
    transition: all 0.3s ease-in-out;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  }

  .card:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  }

  .card-header {
    background-color: #ec407a;
    border: none;
  }

  .card-header > h3 {
    margin: 0;
    color: #FFFFFF;
    text-align: center;
    text-transform: uppercase;
  }

  .card-body > p {
    text-align: center;
    color: #2b2b58;
    margin: 0
  }

  .card-header-edit {
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px 15px;
    color: #FFFFFF;
  }
</style>
